<template>
     <div class="marking content-view">
        <h2 class="fs-24 text-center fc-theme">拼多多打标</h2>
        <p class="subtitle text-center fs-14 fc-666">
            指定多多号推送商品，打上类目标签，商品标签打标，实现拼多多首页推荐</p>
        <top-price code="pddforcescreen"></top-price>
        <div class="flex marginT-20 paddingL-50">
            <el-button type="primary" @click="activeMarkingType = '1'" :plain="activeMarkingType != '1'">拼多多打标</el-button>
            <el-button class="marginL-20" type="primary" @click="activeMarkingType = '2'" :plain="activeMarkingType != '2'">批量打标</el-button>
        </div>
        <div>
            <div class="flex">
                <singe v-if="activeMarkingType == '1'" @refreshRecode="init"></singe>
                <multi v-if="activeMarkingType == '2'" @refreshRecode="init"></multi>
                <div class="flex-2 right">
                    <h3 class="fs-24 marginB-10">拼多多打标</h3>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <el-tabs v-model="activeTip">
                                <el-tab-pane label="打标须知" name="first"></el-tab-pane>
                            </el-tabs>
                        </div>
                        <div class="fs-14" v-if="activeTip == 'first'">
                            <div class="title fc-theme fs-16">拼多多打标</div>
                            <div class="content fs-12 fc-666">
                                1、对指定多多号打标，成功后表现特征：<br> ①、打标的商品出现在被打标的拼多多账号的首页上面。<br> ②、商品出现在拼多多的首页中，或者是同类目出现在首页中。<br> ③、拼多多首页会出现被打标商品常搜到的词。
                            </div>
                            <div class="title fc-theme fs-16">使用场景</div>
                            <div class="content fs-12 fc-666">
                                1.提前对大量多多号打标，并配合做单，可提高商品进入拼多多首页的机会，结合拼多多的千人千面机制，获得更多拼多多搜索流量。
                                <br>2.拼多多没有某些商品的标签，希望能快速的将这些标签词贴到该拼多多账号上，但是想通过核心词搜索下单成交。
                                <br>3.可增加商品在打标多多号猜你喜欢、首页出现的概率。
                                <br>4.回购率很高的商品，可对老客户和咨询未付款的多多号进行推送
                            </div>
                            <div class="title fc-theme fs-16">消费说明</div>
                            <div class="content fs-12 fc-666">
                                1、打标一次非会员{{pricePreMonth.point}}点券/个，会员原价50点券/个，限时优惠{{pricePreMonth.vip_point}}点券/个，点击<span class="fc-blue point" @click="$router.push('/vip')">开通会员</span>。
                                <br>2、打标成功的有效时长根据拼多多更新时间，打标前可以用自己的号测试看下效果，再进行批量打标。
                                <br>3、同一个多多号当日被打标次数超过一定的限度，会降低打标后的效果，建议多多号不宜在一天超过10次打标。
                                <br>4、请求结果成功才会扣取点券，请求结果失败不扣取点券。
                                <br>5、打标成功后，有一定的概率不会直接出现在拼多多APP首页中，介意勿用！
                            </div>
                            <div class="content fc-theme">API接口微信号 {{getkfWx()}}</div>
                        </div>

                    </el-card>
                 </div>
            </div>
        </div>
        <div class="query-record">
            <el-card class="box-card flex-1 marginT-20">
                <div slot="header" class="flex flex-between">
                    <span class="fw-bold fc-333">打标查询记录<span style="font-size: 12px; color: #f00; padding-left: 6px;">(查询记录数据仅保存90天)</span></span>
                    <!-- <span class="fc-theme fs-14">1分钟后自动刷新更新</span> -->
                </div>
                <div>
                    <div class="table">
                        <el-table :data="tableData" fit border>
                            <el-table-column prop="invoke_params.user_ids" label="拼多多id" align="center">
                                <template slot-scope="scope">
                                    <el-popover trigger="hover" placement="top">
                                        <p>{{ scope.row.invoke_params.user_ids || '--'}}
                                        </p>
                                        <div slot="reference"
                                            class="name-wrapper">
                                            {{ scope.row.invoke_params.user_ids || '--'}}
                                        </div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="invoke_params.product_ids" label="宝贝ID"></el-table-column>
                            <el-table-column label="完成时间" :formatter="row => dateFormatUtils(row.invoke_time * 1000)"></el-table-column>
                            <el-table-column :formatter="row => row.result_code == 0 ? '成功' : '失败'" align="center" label="查询结果"></el-table-column>
                            <el-table-column prop="code" align="center"
                                label="备注">
                                <template slot-scope="scope">
                                    <span>操作成功</span>
                                    <!--<el-popover trigger="hover" placement="top">-->
                                    <!--    <p>{{ scope.row.result_message || '&#45;&#45;'}}-->
                                    <!--    </p>-->
                                    <!--    <div slot="reference" class="name-wrapper">-->
                                    <!--        {{ scope.row.result_message || '&#45;&#45;'}}-->
                                    <!--    </div>-->
                                    <!--</el-popover>-->
                                </template>
                            </el-table-column>
                            <el-table-column align="center" width="100" prop="invoke_paid_point" label="消耗点券"></el-table-column>
                        </el-table>
                    </div>
                    <div class="pages marginT-20 text-center">
                        <el-pagination @current-change="handleCurrentChange"
                            :current-page="page" :page-size="5"
                            layout="total, prev, pager, next, jumper"
                            :total="total"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import mixin from '../../mixin/pagination'
import { mapState } from 'vuex'
import singe from './singe'
import multi from './multi'
export default {
    mixins: [mixin],
    computed: mapState(['userData', 'configData', 'phone']),
    components: {
        singe,
        multi
    },
    data() {
        return {
            activeTip: 'first',
            activeMarkingType: '1',
            searchForm: {
                cate: 'tool',
                method: 'pddforcescreen',
                psize: 5
            },
            tableData: [],
            pricePreMonth: {},
            tableUrl: '/tool/accounts/api-record'
        }
    },
    methods: {
        async priceLimit() {
            const data = await this.$fetch('/tool/apps/api-info', {name: 'pddforcescreen'})
            this.pricePreMonth = data.data
        },
    },
    mounted () {
        if (localStorage.token) {
            // this.priceLimit()
            this.init()
        }
    },
}
</script>

<style lang="scss" scoped>
.marking {
    .top-tip {
        padding: 20px 0 6px;
        border-bottom: 1px solid #ddd;
        i {
            color: #ff5920;
        }
    }
    .mark-content {
        padding: 20px;
    }
    .right {
        margin-left: 30px;
        .title {
            margin-top: 5px;
        }
    }
    .name-wrapper {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .el-button--primary.is-plain:hover {
        background: #ecf5ff;
        border-color: #409EFF;
        color: #409EFF;
    }
    .search-block {
        position: relative;
        border: 1px solid #f13d6390;
        padding: 10px 20px 0 20px;
        border-radius: 4px;
        background: #f13d6412;
        .left-btns {
            position: absolute;
            left: -48px;
            display: flex;
            flex-direction: column;
            // width: 40px;
            .el-button + .el-button {
                margin-left: 0;
                margin-top: 10px;
            }
        }
    }
}
</style>
